import { getPerProvinceTrips } from "@/api/group";
import { Loader } from "@/components";
import { useCallback, useEffect, useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/gregorian_en";
import { DateObject } from "react-multi-date-picker";
import IranMap from "./IranMapCanvas";

function Map() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const [from, setFrom] = useState(new DateObject().subtract(1, "year"));
  const [to, setTo] = useState(new DateObject());

  const [showConfig, setShowConfig] = useState(false);
  const [thresh, setThresh] = useState();

  const fetchData = useCallback(() => {
    setLoading(true);

    const params = new URLSearchParams();
    params.append(
      "from",
      from instanceof DateObject
        ? from.convert(persian, persian_fa).format("YYYY-MM-DD")
        : from,
    );
    params.append(
      "to",
      to instanceof DateObject
        ? to.convert(persian, persian_fa).format("YYYY-MM-DD")
        : to,
    );
    Promise.all([getPerProvinceTrips(params.toString())])
      .then((res) => {
        setData(res[0]);
        setThresh({
          midValue: 3,
          criticalValue: 5,
        });
      })
      .finally(() => setLoading(false));
  }, [from, to]);

  useEffect(() => {
    fetchData();
  }, [from, to]);

  return (
    <>
      {loading && <Loader />}
      {data && (
        <IranMap
          reportName={"جهادگران اعزام شده"}
          provinceData={data}
          minThresh={thresh?.criticalValue}
          midThresh={thresh?.midValue}
          outerFrom={from}
          outerTo={to}
          setOuterFrom={setFrom}
          setOuterTo={setTo}
          onClickConfig={() => setShowConfig(true)}
        />
      )}

      {/* <Dialog
        open={showConfig}
        onClose={() => setShowConfig(false)}
        PaperProps={{
          style: {
            backgroundColor: "white",
            borderRadius: "20px",
            boxShadow: "none",
            width: "600px",
            margin: "100px auto",
            padding: "30px",
          },
        }}
      >
        <ThresholdForm
          initValues={{
            midValue: thresh?.midValue,
            criticalValue: thresh?.criticalValue,
          }}
          reportType={"MEMBERS_PER_PROVINCE"}
          onChange={(newThresh) => setThresh(newThresh)}
          onClose={() => setShowConfig(false)}
        />
      </Dialog> */}
    </>
  );
}

export default Map;
